export const UPLOAD_USER_RESUME_REQUEST = 'UPLOAD_USER_RESUME_REQUEST'
export const UPLOAD_USER_RESUME_SUCCESS = 'UPLOAD_USER_RESUME_SUCCESS'
export const UPLOAD_USER_RESUME_FAILED = 'UPLOAD_USER_RESUME_FAILED'
export const SAVE_USER_DEV_UPDATE_RESUME_FILE_INFO = 'SAVE_USER_DEV_UPDATE_RESUME_FILE_INFO'
export const PARSE_USER_RESUME_SUCCESS = 'PARSE_USER_RESUME_SUCCESS'
